var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDeveloper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.832 47.4062H37.5039C37.7188 47.4062 37.8945 47.2305 37.8945 47.0156C37.8945 46.8008 37.7188 46.625 37.5039 46.625H25.832C25.5 46.625 25.2305 46.3555 25.2305 46.0234V38.4922C25.2305 38.2773 25.0547 38.1016 24.8398 38.1016C24.625 38.1016 24.4492 38.2773 24.4492 38.4922V46.0273C24.4531 46.7852 25.0703 47.4062 25.832 47.4062Z",
    fill: "#0B4F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6992 27.8359C25.5977 27.8359 24.6992 28.7344 24.6992 29.8359C24.6992 30.9375 25.5977 31.8359 26.6992 31.8359C27.8008 31.8359 28.6992 30.9375 28.6992 29.8359C28.6992 28.7344 27.8047 27.8359 26.6992 27.8359ZM26.6992 31.0547C26.0273 31.0547 25.4805 30.5078 25.4805 29.8359C25.4805 29.1641 26.0273 28.6172 26.6992 28.6172C27.3711 28.6172 27.918 29.1641 27.918 29.8359C27.918 30.5078 27.3711 31.0547 26.6992 31.0547Z",
    fill: "#0B4F5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.707 28.1602H32.1367C31.1953 28.1602 30.4297 28.9258 30.4297 29.8672C30.4297 30.8086 31.1953 31.5742 32.1367 31.5742H37.707C38.6484 31.5742 39.4141 30.8086 39.4141 29.8672C39.4141 28.9258 38.6484 28.1602 37.707 28.1602ZM37.707 30.7891H32.1367C31.6289 30.7891 31.2109 30.375 31.2109 29.8633C31.2109 29.3516 31.625 28.9375 32.1367 28.9375H37.707C38.2148 28.9375 38.6328 29.3516 38.6328 29.8633C38.6328 30.375 38.2148 30.7891 37.707 30.7891Z",
    fill: "#0B4F5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9062 25.3477H24.1172C22.6094 25.3477 21.3828 26.5742 21.3828 28.082V47.6133C21.3828 49.1211 22.6094 50.3477 24.1172 50.3477H50.9023C52.4102 50.3477 53.6367 49.1211 53.6367 47.6133V28.082C53.6406 26.5742 52.4141 25.3477 50.9062 25.3477ZM52.0781 47.6133C52.0781 48.2578 51.5508 48.7852 50.9062 48.7852H24.1172C23.4727 48.7852 22.9453 48.2578 22.9453 47.6133V33.5547H52.0742V47.6133H52.0781ZM52.0781 32.7734H22.9492V28.082C22.9492 27.4375 23.4766 26.9102 24.1211 26.9102H50.9062C51.5508 26.9102 52.0781 27.4375 52.0781 28.082V32.7734Z",
    fill: "#0B4F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4648 42.3984L31 40.6289L35.4648 38.9219V37.1055L29.0664 39.875V41.418L35.4648 44.1992V42.3984ZM39.7148 35.7656H38.3711L36.0586 45.4219H37.3789L39.7148 35.7656ZM46.7148 39.8867L40.3086 37.1172V38.9063L44.7773 40.6445L40.3086 42.4023V44.207L46.7148 41.418V39.8867Z",
    fill: "#0B4F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDeveloper);
export default __webpack_public_path__ + "static/media/web-developer.ec8745d8039d52c85655356bb51baf66.svg";
export { ForwardRef as ReactComponent };